import { Pagination } from '@core/models/pagination.model';

const ACTION_SCOPE = '[Auth]';
export namespace AuthActions {
  export class Login {
    static readonly type = `${ACTION_SCOPE} Login`;
    constructor(public payload: { email: string; password: string }) {}
  }

  export class Verify2FA {
    static readonly type = `${ACTION_SCOPE} Verify 2FA`;
    constructor(public payload: string) {}
  }

  export class SetLoadingStatus {
    static readonly type = `${ACTION_SCOPE} Set Loading Status`;
    constructor(public loading: boolean) {}
  }

  export class SetSessionStatus {
    static readonly type = `${ACTION_SCOPE} Set Session Status`;
    constructor(public payload: boolean) {}
  }

  export class SetTokenExpiredUrl {
    static readonly type = `${ACTION_SCOPE} Set Token Expired Url`;
    constructor(public payload: string) {}
  }

  export class ResetState {
    static readonly type = `${ACTION_SCOPE} Reset Auth State`;
    constructor() {}
  }

  export class SetTokenValue {
    static readonly type = `${ACTION_SCOPE} Set Token Value`;
    constructor(public token: string) {}
  }

  export class HasApiError {
    static readonly type = `${ACTION_SCOPE} Set Api Error Status`;
    constructor(public token: boolean) {}
  }

  export class ResetPassword {
    static readonly type = `${ACTION_SCOPE} Reset Password`;
    constructor(public payload: { token: string; newPassword: string }) {}
  }

  export class ForgotPassword {
    static readonly type = `${ACTION_SCOPE} Forgot Password`;
    constructor(public payload: { email: string }) {}
  }

  export class SetAuthLoading {
    static readonly type = `${ACTION_SCOPE} Set Auth Loading`;
    constructor(public payload: { loading: boolean }) {}
  }
  export class SetAuthError {
    static readonly type = `${ACTION_SCOPE} Set Auth Error`;
    constructor(public payload: {error: string | null}) {}
  }

  export class SetPermissions {
    static readonly type = `${ACTION_SCOPE} Set Permissions`;
    constructor(public payload: { permissions: { [key: string]: string }[] }) {}
  }

  export class SetGlobalPermissions {
    static readonly type = `${ACTION_SCOPE} Set Global Permissions`;
    constructor(public payload: { globalPermissions: { [key: string]: string }[] }) {}
  }

  export class SetAdminId {
    static readonly type = `${ACTION_SCOPE} Set Admin Id`;
    constructor(public payload: string) {}
  }

  export class LoadPermissions {
    static readonly type = `${ACTION_SCOPE} Load Permissions`;
    constructor() {}
  }
}
